import React, { useState } from "react";
import LoadingSpinner from "./LoadingSpinner";
import CardHeader from "./CardHeader";
import CasePayment from "./CasePayment";
import CaseSignature from "./CaseSignature";
import ProcessPanel from "./ProcessPanel";
import {
  getSignedApplication,
  updateApplicationContent,
} from "../../services/Application";
import { useAuth } from "../../context/AuthContext";
import InfoPopup from "./InfoPopup";

const ApplicationDetails = ({
  applicationData,
  displayModeHandler,
  applicationContent,
  displayMode = "Client",
}) => {
  const { accessToken, checkPermission } = useAuth();
  const [applicationMode, setApplicationMode] = useState("read");
  // const paymentStatuses = [5, 6, 9, 11, 12];
  const paymentStatuses = [5, 6, 11, 12, 13, 14, 15, 16, 17, 18];
  const paymentConfirmedStatuses = [12, 13, 14, 15, 16, 17, 18];
  // const signatureStatuses = [9, 10, 12];
  const signatureStatuses = [10, 12, 13, 14, 15, 16, 17, 18];
  const signatureConfirmedStatuses = [13, 14, 15, 16, 17, 18];
  const downloadApplicationStatuses = [];
  //const downloadApplicationStatuses = [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19];

  const [infoPopupTrigger, setInfoPopupTrigger] = useState(false);

  const [paymentDetailsData, setPaymentDetailsData] = useState({
    editMode: false,
    comment: null,
    data: null,
  });

  const formatDate = (dateString) => {
    const [year, month, day] = dateString.split("-");
    return `${day}.${month}.${year} r.`;
  };

  const validate = () => {
    if (
      paymentDetailsData.editMode &&
      !paymentDetailsData.comment &&
      applicationData.status === 3
    ) {
      setInfoPopupTrigger(true);
      return false;
    }

    return true;
  };

  const onNext = async () => {
    if (paymentDetailsData.editMode) {
      const content = { ...applicationContent };
      content.PaymentOverride = {
        comment: paymentDetailsData.comment,
        data: new Date().toISOString(),
        ...paymentDetailsData.data,
      };

      if (!content.PaymentDetails && !paymentDetailsData.editMode) {
      }

      await updateApplicationContent(
        applicationData.id,
        content,
        null,
        accessToken
      );
    }
    return true;
  };

  useState(() => {
    if (
      applicationData !== null &&
      ((displayMode === "Client" && applicationData.status === 4) ||
        (displayMode === "Operator" && applicationData.status === 3))
    ) {
      setApplicationMode("edit");
    }
  }, [applicationData]);

  if (!applicationData) {
    return (
      <div>
        <CardHeader text="Twój wniosek" onlyText="true" />
        <div className="card container-fluid shadow ms-4 px-4 py-3 w55">
          <div className="d-flex flex-column w47">
            <LoadingSpinner text="Pobieranie danych wniosku" />
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="w-100">
      <CardHeader
        text={displayMode === "Client" ? "Twój wniosek" : "Wniosek"}
        onlyText="true"
      />
      <div className="card container-fluid shadow ms-4 px-4 py-3 w55">
        <div className="d-flex flex-column">
          {displayMode !== "Shipping" && (
            <div className="d-flex flex-column">
              <div className="d-flex flex-row">
                <div>
                  <i className="bi bi-file-earmark-fill text-black-50 fs-1"></i>
                </div>
                <div className="ms-1">
                  <strong>{applicationData.name}</strong>
                  <br />
                  <span className="text-black-50">
                    Utworzono {formatDate(applicationData.createDate)}
                  </span>
                </div>
                <div className="ms-auto">
                  {applicationMode === "edit" ? (
                    <button
                      className="btn btn-primary ms-auto w11 h2"
                      onClick={() => displayModeHandler(0)}
                    >
                      Edycja
                    </button>
                  ) : (
                    <button
                      className="btn btn-outline-primary ms-auto w11 h2"
                      onClick={() => displayModeHandler(0)}
                    >
                      Podgląd
                    </button>
                  )}
                </div>
              </div>

              {downloadApplicationStatuses.includes(applicationData.status) && (
                <div className="d-flex flex-row mt-1">
                  <button
                    className="btn btn-outline-primary ms-auto w11 h2"
                    onClick={() =>
                      getSignedApplication(
                        applicationData.id,
                        "wniosek_CO_podgląd.pdf",
                        accessToken
                      )
                    }
                  >
                    Pobierz PDF
                  </button>
                </div>
              )}
            </div>
          )}

          {(paymentStatuses.includes(applicationData.status) ||
            (applicationData.status === 3 &&
              checkPermission("Zmiana przypisania sprawy"))) && (
            <CasePayment
              status={
                paymentConfirmedStatuses.includes(applicationData.status)
                  ? "paid"
                  : applicationData.status === 3
                  ? "toedit"
                  : "pending"
              }
              applicationData={applicationData}
              displayMode={displayMode}
              disablePaymentButtons={applicationData.status === 5}
              editPaymentDetailsData={paymentDetailsData}
              setEditPaymentDetailsData={setPaymentDetailsData}
              applicationContent={applicationContent}
            />
          )}
          {signatureStatuses.includes(applicationData.status) && (
            <CaseSignature
              status={
                applicationData.status === 12
                  ? "readyToSign"
                  : signatureConfirmedStatuses.includes(applicationData.status)
                  ? "signed"
                  : "pending"
              }
              id={applicationData.id}
              signedApplication={applicationData.SignedApplication}
              displayMode={displayMode}
              applicationNumber={applicationData.number}
              attachments={applicationData.Attachments}
              signedBy={applicationData.signedBy}
              exporterName={applicationData.exporterName || ""}
              agentName={applicationData.agentName || ""}
              agentFiles={applicationData.agentFiles || []}
            />
          )}

          <ProcessPanel embedded={true} validate={validate} onNext={onNext} />
        </div>
      </div>
      <InfoPopup
        title={"Błąd"}
        trigger={infoPopupTrigger}
        errorDescription={{
          Errors: [
            {
              Header: "Błąd walidacji",
              Description: ["Pole Komentarz jest wymagane."],
            },
          ],
        }}
        errorMode={true}
      />
    </div>
  );
};

export default ApplicationDetails;
